<template>
    <q-list no-border class="bg-faded">
        <q-item v-for="menu in menus" :key="menu.name"
                              v-ripple link item exact class="big text-white" :to="menu.slug">
            {{ $T(menu.name) }}
        </q-item>
        <div v-if="multilingue">
            <ul>
                <q-item item>
                <li class="lang pt" style="margin: 0 0 15px">
                    <router-link to="/lang/pt/*">pt</router-link>
                </li>
                </q-item>
                <q-item item>
                <li class="lang es">
                    <router-link to="/lang/es/*">es</router-link>
                </li>
                </q-item>
            </ul>
        </div>
        <q-item-separator/>
        
        <q-item link :to="{name: 'contact'}" class="big text-white">{{ $T('contact us') }}</q-item>
        <q-item link :to="{name: 'tec'}" class="big text-white">{{ $T('terms ans conditions') }}</q-item>
        <q-item link :to="{name: 'cancel-subscription'}" class="big text-white">{{ $T('cancel') }}</q-item>
    </q-list>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {loadMessages} from '../plugins/i18n'

    import {
        QList,
        QPopover,
        QListHeader,
        QItem,
        QItemSeparator,
        QBtn,
        QInput
    } from 'quasar-framework'

    export default {
        data: () => ({
            language: window.config.locale,
            lang: '',
            redirect: '',
            logo: `${config.appUrl}${config.devAssetsFolder}/img/p4f.svg`,
            query: '',
            enabledLanguages: window.config.enabled_locales,
            multilingue: window.config.multilingue,
            selected: ''
        }),
        components: {
            QList,
            QPopover,
            QListHeader,
            QItem,
            QItemSeparator,
            QBtn,
            QInput
        },

        computed: {
            ...mapGetters({
                user: 'auth/user',
                locale: 'lang/locale',
                locales: 'lang/locales',
            }),

            menus() {
                this.redirect = '/'+this.$route.path.split('/').join('*')
                return window.config.menus
            }
        },

        methods: {
            async logout() {
                // Log out the user.
                await this.$store.dispatch('auth/logout')

                // Redirect to login.
                this.$router.push({name: "home"}).catch(()=>{})
            },

            setLocale(locale) {
                if (this.$i18n.locale !== locale) {
                    loadMessages(locale)

                    this.$store.dispatch('lang/setLocale', {locale})
                }
            },

            search() {
                this.$router.push({ name: 'sports.search', params: {query: this.query} }).catch(()=>{})
            },

            getVersion() {
                return `${config.appVersion}`
            },
        }
    }
</script>

<style scoped>
    .lang{
        margin-left: 0;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Menu.vue